'use client'

/***
 *
 * @file components/ScrollLink/index.tsx
 * @description ScrollLink component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Truminds Software System
 * @since 13 Feb 2024
 *
 */

import React, { PropsWithChildren } from "react";
// import "./ScrollLink.scss";
import Link, { LinkProps } from "next/link";
import CustomLink from "../CustomLink";
import { useRouter } from "next/navigation";

// mirror the props of next/link component
type T_AnchorProps = Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  keyof LinkProps
>;

export type T_ScrollLinkProps = T_AnchorProps & LinkProps & PropsWithChildren & {
  data?: any,
  menuIndex?: number,
  onClick?: any,
  pathName?: string | undefined,
  locale?: string,
  className?: string
};

const ScrollLink = ({ children, data, menuIndex, onClick, pathName, className, ...rest }: T_ScrollLinkProps) => {
  const router = useRouter();
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    //remove everything before the hash
    const targetId = e.currentTarget.href.replace(/.*\#/, "").split("/")[0].split("?")[0];
    if(e.currentTarget.href.match(/.*\#/) && e.currentTarget.pathname === pathName) {
      e.preventDefault();
      // console.log("Menu clicks step 1");
      const elem = document.getElementById(targetId);
      window.scrollTo({
        top: elem?.getBoundingClientRect().top,
        behavior: "smooth",
      });
    } else if(e.currentTarget.href.match(/.*\#/)) {
      // const urlStr = (Array.isArray(e.currentTarget.hash.split("/")?.pop()) ? e.currentTarget.hash.split("/")?.pop()?.join("/") : e.currentTarget.hash.split("/")?.pop())
      e.preventDefault();
      // console.log("Menu clicks step 2");
      // e.currentTarget.href = e.currentTarget.href.replace(/.*\#/, "");
      // router.push(e.currentTarget.href.replace(/.*\#/, ""));
      router.push(`${e.currentTarget.pathname}${e.currentTarget.hash.split("/")?.pop()}`);
      setTimeout(() => {
        const elem = document.getElementById(targetId);
        window.scrollTo({
          top: elem?.getBoundingClientRect().top,
          behavior: "smooth",
        });
      }, 300);
    } else {
      // console.log("Menu clicks step 3")
      router.push(e.currentTarget.href);
    }
      
    // //remove everything before the hash
    // const targetId = e.currentTarget.href.replace(/.*\#/, "").split("/")[0].split("?")[0];
    // const elem = document.getElementById(targetId);
    // // console.log("Menu clicks", (Array.isArray(e.currentTarget.hash.split("/")?.pop()) ? e.currentTarget.hash.split("/")?.pop()?.join("/") : e.currentTarget.hash.split("/")?.pop()), e.currentTarget.href.replace(/.*\#/, ""), targetId, elem, e.currentTarget.pathname)
    // window.scrollTo({
    //   top: elem?.getBoundingClientRect().top,
    //   behavior: "smooth",
    // });
  };
  return (
    <CustomLink data-testid="ScrollLink" role="button" data={data} menuIndex={menuIndex} cssClass={className} {...rest} onClick={(e)=>{
      onClick
      handleScroll(e);
    }}>
      {children}
    </CustomLink>
  );
};
export default ScrollLink;
